import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { makePublicFeatureFlagGuard, RedirectGlobalAdmin } from '@ftr/ui-core'
import { RedirectToLiveStreamRecording } from '@ftr/ui-realtime-playback'
import { AuthenticationGuard } from '@ftr/ui-user'
import { HelpPageModule } from '~app/pages/help/help-page.module'
import { MultifactorAuthenticationPagesModule } from '~app/pages/multifactor-authentication/multifactor-authentication-pages.module'
import { NotFoundPage } from './pages/not-found.page'
import { PasswordResetPagesModule } from './pages/password-reset/password-reset-pages.module'
import { RootModule } from './pages/root.module'
import { SignupPagesModule } from './pages/signup/signup-pages.module'

@NgModule({
  imports: [
    RootModule,
    SignupPagesModule,
    PasswordResetPagesModule,
    HelpPageModule,
    MultifactorAuthenticationPagesModule,
    RouterModule.forRoot(
      [
        {
          path: AppPaths.DefaultPage,
          data: {
            breadcrumb: 'Home',
            title: 'Home',
          },
          children: [
            {
              path: AppPaths.DefaultPage,
              loadChildren: () => import('./pages/home/home-page.module').then(m => m.HomePageModule),
            },
            {
              path: `${AppPaths.Admin}/${AppPaths.CourtSystems}/:courtSystemId`,
              canActivate: [AuthenticationGuard, RedirectGlobalAdmin],
              component: NotFoundPage, // Dummy Component, guard will always redirect
            },
            {
              path: `${AppPaths.Admin}/livestream`,
              canActivate: [AuthenticationGuard],
              component: RedirectToLiveStreamRecording, // Redirects to a currently live stream recording (particularly useful for local dev)
            },
            {
              path: AppPaths.Admin,
              canActivate: [AuthenticationGuard, RedirectGlobalAdmin],
              component: NotFoundPage, // Dummy Component, guard will always redirect
              children: [
                {
                  path: '**',
                  component: NotFoundPage, // Dummy Component, guard will always redirect
                },
              ],
            },
            {
              path: AppPaths.CourtSystem,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/court-system/court-system-pages.module').then(m => m.CourtSystemPagesModule),
            },
            {
              path: AppPaths.CourtSystems,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/court-system/court-system-pages.module').then(m => m.CourtSystemPagesModule),
            },
            {
              path: AppPaths.Jobs,
              canActivate: [AuthenticationGuard],
              loadChildren: () => import('./pages/jobs/jobs-pages.module').then(m => m.JobsPagesModule),
            },
            {
              path: AppPaths.Orders,
              canActivate: [AuthenticationGuard],
              loadChildren: () => import('./pages/orders/orders-pages.module').then(m => m.OrdersPagesModule),
            },
            {
              path: AppPaths.SharedWithMe,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/shared-with-me/shared-with-me-pages.module').then(m => m.SharedWithMePagesModule),
            },
            {
              path: AppPaths.Account,
              canActivate: [AuthenticationGuard],
              loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule),
            },
            {
              path: AppPaths.AuditLog,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/my-audit-log/my-audit-log-pages.module').then(m => m.MyAuditLogPagesModule),
            },
            {
              path: AppPaths.Transcripts,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/transcripts/transcripts-page.module').then(m => m.TranscriptsPageModule),
            },
            {
              path: AppPaths.SharedRecordings,
              canActivate: [AuthenticationGuard],
              loadChildren: () =>
                import('./pages/shared-recordings/shared-recordings-pages.module').then(
                  m => m.SharedRecordingsPagesModule,
                ),
            },
            {
              path: AppPaths.Access,
              canActivate: [AuthenticationGuard, makePublicFeatureFlagGuard('public-navigation')],
              loadChildren: () => import('./pages/access/access-pages.module').then(m => m.AccessPagesModule),
            },
          ],
        },
        {
          path: '**',
          component: NotFoundPage,
          canActivate: [AuthenticationGuard],
        },
      ],
      {
        canceledNavigationResolution: 'computed',
      },
    ),
    RootModule,
    SignupPagesModule,
    PasswordResetPagesModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
